import { render, staticRenderFns } from "./VideoAgv.vue?vue&type=template&id=9654f61a&scoped=true&"
import script from "./VideoAgv.vue?vue&type=script&lang=js&"
export * from "./VideoAgv.vue?vue&type=script&lang=js&"
import style0 from "./VideoAgv.vue?vue&type=style&index=0&id=9654f61a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9654f61a",
  null
  
)

export default component.exports